import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.css']
})
export class CalculatorComponent implements OnInit {
  form;
  formValues = {
    rentOrMortgage: 0,
    gasWaterLight: 0,
    telephoneTVInternet: 0,
    insurancePremiums: 0,
    subscriptionFees: 0,
    roadTaxOZB: 0,
    otherFixedCharges: 0,
    businessRentOrMortgage: 0,
    businessGasWaterLight: 0,
    businessInsurancePremiums: 0,
    businessSubscriptionFees: 0,
    businessCarLeaseAmount: 0,
    businessOtherExpenses: 0,
    additionalAmount: 0,
    businessExpenses: false,
  };
  ownFields = [
    {
      title: 'Calculator.RentOrMortgage',
      name: 'rentOrMortgage'
    },
    {
      title: 'Calculator.GasWaterLight',
      name: 'gasWaterLight'
    },
    {
      title: 'Calculator.TelephoneTVInternet',
      name: 'telephoneTVInternet'
    },
    {
      title: 'Calculator.InsurancePremiums',
      name: 'insurancePremiums'
    },
    {
      title: 'Calculator.SubscriptionFees',
      name: 'subscriptionFees'
    },
    {
      title: 'Calculator.RoadTaxOZB',
      name: 'roadTaxOZB'
    },
    {
      title: 'Calculator.OtherFixedCharges',
      name: 'otherFixedCharges'
    },
  ];

  businessFields = [
    {
      title: 'Calculator.BusinessRentOrMortgage',
      name: 'businessRentOrMortgage'
    },
    {
      title: 'Calculator.BusinessGasWaterLight',
      name: 'businessGasWaterLight'
    },
    {
      title: 'Calculator.BusinessInsurancePremiums',
      name: 'businessInsurancePremiums'
    },
    {
      title: 'Calculator.BusinessSubscriptionFees',
      name: 'businessSubscriptionFees'
    },
    {
      title: 'Calculator.BusinessCarLeaseAmount',
      name: 'businessCarLeaseAmount'
    },
    {
      title: 'Calculator.BusinessOtherExpenses',
      name: 'businessOtherExpenses'
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<CalculatorComponent>,
    public formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: object
  ) {
    this.form = this.formBuilder.group(data ? data : this.formValues);
  }

  ngOnInit(): void {}

  closeDialog(): void {
    this.dialogRef.close(this.calculatorData);
  }

  additionalAmountChanged(): void {
    const additionalAmount = this.form.controls.additionalAmount.value;
    if (additionalAmount > 750) {
      this.form.controls.additionalAmount.setValue(750);
    }
  }

  get calculatorData(): { formValues: object, amount: number } {
    const arrayOfFields = [...this.ownFields, ...this.businessFields ];
    const additionalAmount = this.form.controls.additionalAmount.value;
    const businessExpenses = this.form.controls.businessExpenses.value;
    const formValues = { additionalAmount, businessExpenses };
    const amount = arrayOfFields.reduce((acc, item) => {
      const formValue = this.form.controls[item.name].value || 0;
      formValues[item.name] = formValue;
      return acc + formValue;
    }, additionalAmount);
    return { formValues, amount };
  }

  get showBusinessExpenses(): boolean {
    return this.form.controls.businessExpenses.value;
  }
}
